import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { UNAUTHORIZED, FORBIDDEN } from 'http-status-codes';
import { Redirect, useHistory } from 'react-router-dom';

import { StoreBasicDataApiStructure } from 'common/types';
import { ROOT_ROUTE } from 'common/constants';
import { repositories } from 'api';
import { meOperations } from 'store/ducks/me';

type Props = StoreBasicDataApiStructure<repositories.MeType> & {
    fetchMe: Function,
    redirectionPath: string,
};

const Auth: React.FC<Props> = ({ errorCode, isLoading, redirectionPath, }) => {
    const history = useHistory();

    useEffect(() => {
        // TODO PB Make revision routes architecture and check two endpoints calling (me, info).
        if (history.location.pathname === ROOT_ROUTE) {
            history.push('/products');
            return;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) {
        return null;
    }

    switch (errorCode) {
        case UNAUTHORIZED: {
            const redirectParams = {
                pathname: '/login',
                state: {
                    referrer: redirectionPath,
                },
            };

            return <Redirect to={redirectParams} />;
        }

        case FORBIDDEN: {
            return <Redirect to="/access-information" />;
        }

        default: {
            return null;
        }
    }
};

type MappingType = {
    me: StoreBasicDataApiStructure<repositories.MeType>;
};

const mapStateToProps = ({ me }: MappingType) => me;

const mapDispatchToProps = {
    fetchMe: meOperations.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
